import { useState } from 'react';
import '../Assets/Css/cleaning.css';
import { Container, Row, Col, Card, Modal, Button } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import aboutsecurity from '../Assets/Image/aboutcleaningimage.jpg'
import ctasecureimg from '../Assets/Image/ctacleaningservice.avif'

import carpetChairImg from '../Assets/Image/carpetshampoomachine.avif'
import tankCleaningImg from '../Assets/Image/industrialtankcleaning.jpg'
import facadeGlassImg from '../Assets/Image/FacadeGlassCleaning.jpg'
import highRiseRoofImg from '../Assets/Image/highrise.avif'
import floorCleaningImg from '../Assets/Image/industrialfloorcleaning.avif'

import carpetChairImg1 from '../Assets/Image/Carpet Chair Shampooing Services1.avif'
import tankCleaningImg1 from '../Assets/Image/tank-cleaning1.avif'
import facadeGlassImg1 from '../Assets/Image/facade-cleaning1.avif'
import highRiseRoofImg1 from '../Assets/Image/highreise1.avif'
import floorCleaningImg1 from '../Assets/Image/Floorcleaning1.avif'

import carpetChairImg2 from '../Assets/Image/Carpet  Chair Shampooing Services2.avif'
import tankCleaningImg2 from '../Assets/Image/tank-cleaning1.jpg'
import facadeGlassImg2 from '../Assets/Image/facade-cleaning2.avif'
import highRiseRoofImg2 from '../Assets/Image/highreise2.avif'
import floorCleaningImg2 from '../Assets/Image/Floorcleaning2.avif'

import { Helmet } from 'react-helmet';


export default function CleaningServices() {

  const testimonials = [
    {
      message: "Their cleaning team transformed our workspace! The attention to detail and commitment to hygiene is truly impressive.",
      author: "Facility Manager",
    },
    {
      message: "From facade cleaning to floor polishing, every service was delivered on time and exceeded our expectations. Highly recommended!",
      author: "Admin Executive",
    },
    {
      message: "We’ve been using their industrial cleaning services for over a year — consistent, reliable, and always spotless!",
      author: "Maintenance Head",
    },
  ];


  const services = [
    {
      title: 'High Rise Roof & Structure Cleaning',
      description: 'We specialize in cleaning the roofs and structural elements of high-rise buildings using advanced safety gear and industrial tools. Our certified team uses rope access systems, pressure washers, and long-reach equipment to safely remove dirt, grime, and bird droppings without disrupting your building’s daily operations. This service helps extend structural life and maintains a professional look.',
      image: highRiseRoofImg,
      relatedImages: [highRiseRoofImg, highRiseRoofImg1, highRiseRoofImg2],
      keyFeatures: [
        'Trained professionals with safety certifications',
        'Use of industrial-grade harnesses and tools',
        'Zero disruption to building operations'
      ],
      applicationAreas: [
        'Corporate office buildings',
        'Residential skyscrapers',
        'Hospitals and hotels',
        'Commercial complexes'
      ]
    },
    {
      title: 'High Rise Glass (Facade) Cleaning',
      description: 'Our team uses rope access or suspended cradle systems to clean the exterior glass of high-rise buildings. We apply eco-friendly cleaning agents and squeegees to achieve a spotless, streak-free finish. This service enhances the building’s appearance and maximizes sunlight exposure inside the property.',
      image: facadeGlassImg,
      relatedImages: [facadeGlassImg, facadeGlassImg1, facadeGlassImg2],
      keyFeatures: [
        'Safe rope-access and suspended platform techniques',
        'Spot-free, streak-free glass finish',
        'Environmentally friendly cleaning agents'
      ],
      applicationAreas: [
        'Office towers',
        'Residential apartments',
        'Shopping malls',
        'Hotels and convention centers'
      ]
    },
    {
      title: 'Industrial Tanks Cleaning',
      description: 'We provide internal and external cleaning of industrial tanks, silos, and pressure vessels. Our trained professionals enter confined spaces using full PPE, applying chemical or mechanical methods (scrubbing, jetting) to remove sludge, scale, and contaminants. This service ensures hygiene, operational safety, and compliance with industry standards.',
      image: tankCleaningImg,
      relatedImages: [tankCleaningImg, tankCleaningImg1, tankCleaningImg2],
      keyFeatures: [
        'Confined space entry trained teams',
        'Chemical and mechanical cleaning methods',
        'Strict adherence to industry compliance standards'
      ],
      applicationAreas: [
        'Manufacturing plants',
        'Chemical and pharma units',
        'Water treatment facilities',
        'Food and beverage industries'
      ]
    },
    {
      title: 'Industrial & Commercial Floor Deep Cleaning',
      description: 'Our team uses heavy-duty auto-scrubbers, buffers, and high-pressure jet machines to deeply clean factory, warehouse, and commercial floors. We remove grease, dust, and hard stains from concrete, epoxy, or tile surfaces. This service improves safety, aesthetics, and durability of flooring in industrial environments.',
      image: floorCleaningImg,
      relatedImages: [floorCleaningImg, floorCleaningImg1, floorCleaningImg2],
      keyFeatures: [
        'Use of ride-on and walk-behind scrubbers',
        'Effective removal of grease, dust, and stains',
        'Customized for epoxy, concrete, or tile surfaces'
      ],
      applicationAreas: [
        'Factories and workshops',
        'Logistics warehouses',
        'Retail outlets',
        'Airports and terminals'
      ]
    },
    {
      title: 'Carpet & Chair Shampooing Services',
      description: 'We deep-clean carpets, office chairs, and sofas using hot water extraction or dry foam shampooing. Our process includes vacuuming, pre-treatment, shampooing, and quick drying using blowers. This service removes dirt, allergens, and stains, extending the life of upholstery and enhancing hygiene in workspaces.',
      image: carpetChairImg,
      relatedImages: [carpetChairImg, carpetChairImg1, carpetChairImg2],
      keyFeatures: [
        'Eco-friendly shampooing chemicals',
        'Hot water extraction and dry foam methods',
        'Removes dust mites, allergens, and stubborn stains'
      ],
      applicationAreas: [
        'Corporate offices',
        'Schools and colleges',
        'Theaters and auditoriums',
        'Healthcare centers'
      ]
    }
  ];





  const [showModal, setShowModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [activeImage, setActiveImage] = useState(null);

  const handleOpenModal = (service) => {
    setSelectedService(service);
    setActiveImage(service.image);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedService(null);
  };


  return (
    <div className="mainnav min-vh-100">
      <Helmet>
        {/* Basic SEO */}
        <title>Cleaning Services | High-Rise, Industrial & Commercial Cleaning - Pradh</title>
        <meta
          name="description"
          content="Explore specialized cleaning services by Pradh — including high-rise facade cleaning, industrial tank cleaning, deep floor cleaning, and more. Safe, eco-friendly & professional."
        />
        <meta
          name="keywords"
          content="Industrial Cleaning Services, High-Rise Facade Cleaning, Tank Cleaning, Floor Scrubbing, Chair Shampooing, Commercial Cleaning India, Pradh Management Solutions"
        />
        <meta name="author" content="Pradh Management Solutions" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Professional Cleaning Services | Pradh Management Solutions" />
        <meta
          property="og:description"
          content="High-rise, industrial, and commercial cleaning by Pradh. Safe, effective and eco-conscious solutions tailored for modern facilities across India."
        />
        <meta property="og:url" content="https://pradh.com/cleaning-services" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://pradh.com/images/cleaning-services-banner.jpg" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Cleaning Services | Pradh Management Solutions" />
        <meta
          name="twitter:description"
          content="From high-rise facade cleaning to industrial tank and deep floor scrubbing — Pradh delivers expert cleaning services across sectors."
        />
        <meta name="twitter:image" content="https://pradh.com/images/cleaning-services-banner.jpg" />

        {/* Canonical */}
        <link rel="canonical" href="https://pradh.com/cleaning-services" />
      </Helmet>


      {/* Hero Section */}
      <section className="hero-section3">
        <div className="overlay text-center text-white d-flex flex-column justify-content-center align-items-center">
          <h1 data-aos="zoom-in">Cleaning Services</h1>
          <p data-aos="zoom-in" data-aos-delay="100">
            Professional, Safe & Specialized Cleaning Solutions for Every Surface
          </p>
          <a href="/contact" className="btn-get mt-3" data-aos="fade-up" >Get in Touch</a>
        </div>
      </section>

      {/* About Us Section */}
      <section className="about-us py-5">
        <Container>
          <Row>
            <Col
              md={5}
              className="d-flex justify-content-center align-items-center"
            >
              <img
                src={aboutsecurity} // Replace this with your cleaning-related image (e.g., aboutCleaningImg)
                alt="About Cleaning Services"
                className="img-fluid aboutsecimg rounded shadow mb-3"
                data-aos="zoom-in"
                data-aos-delay="100"
              />
            </Col>
            <Col md={7}>
              <h2 className="page-title text-center" data-aos="fade-up">
                Overview
              </h2>
              <p data-aos="zoom-in" data-aos-delay="100">
                At  <strong style={{ color: '#04A1D3' }}> Pradh Management Solutions</strong>, we offer specialized cleaning services designed for high-rise structures, industrial plants, and commercial spaces. Our expert team is equipped with advanced tools and techniques to deliver exceptional cleanliness and hygiene across all environments.
              </p>
              <p data-aos="zoom-in" data-aos-delay="100">
                From rope-access facade and roof cleaning to deep floor scrubbing and industrial tank maintenance, we ensure every surface is thoroughly cleaned and maintained to meet safety and operational standards. We prioritize eco-friendly methods and zero disruption to client operations.
              </p>
              <p data-aos="zoom-in" data-aos-delay="100">
                Whether it’s a corporate office, factory, or residential high-rise, our comprehensive solutions enhance both aesthetics and safety while extending the life of your infrastructure and assets.
              </p>
            </Col>
          </Row>
        </Container>
      </section>









      {/* Services Section */}




      <section className="services-content py-5 bg-light">
        <Container>
          <h2 className="page-title text-center mb-5" data-aos="fade-up">
            Our Specialized Cleaning Services
          </h2>
          <div className="custom-grid">
            {services.map((service, index) => (
              <div className="custom-col" key={index} data-aos="zoom-in" data-aos-delay="100">
                <div className="service1-card h-100">
                  <div className="service1-image-wrapper">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="service1-image"
                    />
                  </div>
                  <div className="service1-body px-3 pt-3">
                    <h5 className="service1-title">{service.title}</h5>
                  </div>
                  <div className="quickview-btn px-3 pb-3 d-flex align-items-center">
                    <span className="quickview-text" onClick={() => handleOpenModal(service)} style={{ cursor: 'pointer' }}>
                      Quick View <MdOutlineKeyboardDoubleArrowRight size={22} className=" arrow-icon" />
                    </span>

                  </div>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>

      {selectedService && (
        <Modal show={showModal} className='mt-5 pb-5' onHide={handleCloseModal} size="lg" centered>

          {/* Close (X) Button Header */}
          <Modal.Header closeButton className="border-0 pb-0">
            {/* Optional: Add a title or leave it empty */}
            <Modal.Title></Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row>
              {/* Left - Images (Col-5) */}
              <Col md={5}>
                <img src={activeImage} alt="Main View" className="img-fluid modalimg mb-3 rounded" />
                <div className="d-flex gap-2 mb-3 flex-wrap">
                  {selectedService.relatedImages.map((img, idx) => (
                    <img
                      key={idx}
                      src={img}
                      alt={`Related ${idx}`}
                      className="img-thumbnail"
                      style={{ width: '90px', height: '100px', cursor: 'pointer' }}
                      onClick={() => setActiveImage(img)}
                    />
                  ))}
                </div>
              </Col>

              {/* Right - Text Info (Col-7) */}
              <Col md={7}>
                <h4 className="text-center text-md-start">{selectedService.title}</h4>
                <p>{selectedService.description}</p>

                <h6>Key Features:</h6>
                <ul>
                  {selectedService.keyFeatures.map((feature, i) => (
                    <li key={i}>{feature}</li>
                  ))}
                </ul>

                {selectedService.applicationAreas && (
                  <>
                    <h6>Application Areas:</h6>
                    <ul>
                      {selectedService.applicationAreas.map((area, i) => (
                        <li key={i}>{area}</li>
                      ))}
                    </ul>
                  </>
                )}
              </Col>

            </Row>
          </Modal.Body>
        </Modal>
      )}



      {/* Contact CTA Section */}
      <section className="contact-cta py-4 text-center">
        <Container>
          <Row className="align-items-center">
            <Col md={7} className="text-center text-md-start mb-3" data-aos="zoom-in" data-aos-delay="100">
              <h2>Looking for Reliable & Professional Cleaning Services</h2>
              <p className="lead">
                Get in touch with our expert team for a free consultation and site visit
              </p>
              <a href="/contact" className="btn-get">Request a Quote</a>
            </Col>


            <Col md={5}>
              <div className="d-flex justify-content-center" data-aos="zoom-in" data-aos-delay="200">
                <img
                  src={ctasecureimg}
                  alt="Professional service team at work"
                  className="img-fluid  rounded shadow"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>


      {/* Testimonials Section */}
      <section className="testimonials py-5 bg-light">
        <Container>
          <h2 className="page-title text-center">What Our Clients Say</h2>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={30}
                slidesPerView={1}
                autoplay={{ delay: 5000 }}
                loop={true}
                pagination={{ clickable: true }}
              >
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <Card className="p-4 mb-4 border-0 text-center" data-aos="zoom-in" data-aos-delay="100">
                      <p>⭐️⭐️⭐️⭐️⭐️</p>
                      <p className="mb-3" style={{ fontStyle: 'italic' }}>“{testimonial.message}”</p>
                      <small className="text-muted">— {testimonial.author}</small>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}
